import { z } from "@/zod";

import {
  rate,
  storeId,
  departmentId,
  settlementTypeHourlyRates,
} from "@/schemas/commonFields";

const departmentBasedProjectRates = z.object({
  id: z.string(),
  payroll_department_id: departmentId,
  payroll_department_name: z.string(),
  store_id: storeId,
  store_name: z.string(),
  valid_from: z.string().date(),
  settlement_type: z.union([settlementTypeHourlyRates, z.literal("")]),
  ...rate.shape,
});
export const readDepartmentBasedProjectRates =
  departmentBasedProjectRates.readonly();
export type ReadDepartmentBasedProjectRates = z.infer<
  typeof readDepartmentBasedProjectRates
>;

export const writeDepartmentBasedProjectRates =
  departmentBasedProjectRates.omit({
    id: true,
    payroll_department_name: true,
    store_name: true,
  });
export type WriteDepartmentBasedProjectRates = z.infer<
  typeof writeDepartmentBasedProjectRates
>;
